/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LavoriSpeseInsertDTO
 */
export interface LavoriSpeseInsertDTO {
    /**
     * 
     * @type {number}
     * @memberof LavoriSpeseInsertDTO
     */
    idTipoRimborso?: number;
    /**
     * 
     * @type {number}
     * @memberof LavoriSpeseInsertDTO
     */
    totale?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof LavoriSpeseInsertDTO
     */
    nonAddebitabile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LavoriSpeseInsertDTO
     */
    sostenuteSocieta?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LavoriSpeseInsertDTO
     */
    note?: string | null;
}

/**
 * Check if a given object implements the LavoriSpeseInsertDTO interface.
 */
export function instanceOfLavoriSpeseInsertDTO(value: object): value is LavoriSpeseInsertDTO {
    return true;
}

export function LavoriSpeseInsertDTOFromJSON(json: any): LavoriSpeseInsertDTO {
    return LavoriSpeseInsertDTOFromJSONTyped(json, false);
}

export function LavoriSpeseInsertDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LavoriSpeseInsertDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idTipoRimborso': json['idTipoRimborso'] == null ? undefined : json['idTipoRimborso'],
        'totale': json['totale'] == null ? undefined : json['totale'],
        'nonAddebitabile': json['nonAddebitabile'] == null ? undefined : json['nonAddebitabile'],
        'sostenuteSocieta': json['sostenuteSocieta'] == null ? undefined : json['sostenuteSocieta'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function LavoriSpeseInsertDTOToJSON(json: any): LavoriSpeseInsertDTO {
    return LavoriSpeseInsertDTOToJSONTyped(json, false);
}

export function LavoriSpeseInsertDTOToJSONTyped(value?: LavoriSpeseInsertDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idTipoRimborso': value['idTipoRimborso'],
        'totale': value['totale'],
        'nonAddebitabile': value['nonAddebitabile'],
        'sostenuteSocieta': value['sostenuteSocieta'],
        'note': value['note'],
    };
}

